import Text from '../Text';

const Intro = ({ children }) => {
  return <Text type='leadParagraph'>{children}</Text>;
};

export default Intro;
